module.exports = __webpack_public_path__ + "img/IFPI_Logo_blue_Primary.855a95ef.svg";